export default {
  title: 'Novo Usergroup',
  description: 'Permite a criação de um novo Grupo de Usuário para um usuário Master cadastrado.',
  total: 'Total de créditos: ',
  usedTotal: 'Créditos em uso: ',
  nonUsedTotal: 'Créditos livres: ',
  usedDetails: 'Detalhes de créditos em uso: ',
  productModule: 'Módulo',
  productName: 'Produto',
  productAmount: 'Quantidade',
  opportunityId: 'ID da oportunidade',
  creationDate: 'Data de criação',
  productId: 'ID do Produto',
  expirationDate: 'Data de expiração',
  monthLimit: 'Limite mensal',
  totalLimit: 'Limite Total',
  account: 'Conta',
  universe: 'Pesquisa',
  page: 'Página',
  service: 'Atendimento',
  proprietaryMetrics: 'Métricas Proprietárias',
  listening: 'Listening',
  capacity: 'Base (Capacidade)'
};
